import { IKorfineAttachments, IKorfineContractDocument, KorfineAttachmentSection } from "../models/property/property-korfine.model";

// Order and document type mirror WinApp UCKorfine.GetAttachment/AddAttachment.
export const KORFINE_ATTACHMENT_SECTIONS: KorfineAttachmentSection[] = ["OWNER", "OWNERPARTNER", "TENANT", "TENANTPARTNER"];
export const KORFINE_DOCUMENT_TYPE = "TenantId";
// Person document type WinApp pre-selects as the ID card (UCExtraAttachment.LoadAttachmentsAsync: DocumentType = 5).
export const KORFINE_ID_CARD_DOCUMENT_TYPE_ID = 5;

export function korfineDocumentFileName(fileName: string, section: KorfineAttachmentSection): string {
    const dot = fileName.lastIndexOf(".");
    return dot > 0 ? `${fileName.slice(0, dot)}_${section}${fileName.slice(dot)}` : `${fileName}_${section}`;
}

export function buildKorfineContractDocuments(attachments?: IKorfineAttachments): IKorfineContractDocument[] | null {
    const documents = KORFINE_ATTACHMENT_SECTIONS.flatMap(section =>
        (attachments?.[section] || []).map(item => ({
            DocumentType: KORFINE_DOCUMENT_TYPE,
            FileName: korfineDocumentFileName(item.Filename, section),
            FileUrl: item.FileUrl
        })));
    return documents.length > 0 ? documents : null;
}
